import { StakeInputParser } from "./StakeInputParser";
export * from "./StakeInputParser";
window.StakeInputParser = new StakeInputParser(UseCommaAndDotAsDecimalSeparator ? [".", ","] : [DecimalSeparator], MoneyFormat);
//# sourceMappingURL=index.js.map